export default __webpack_public_path__ + "media/images/react_icons/arrow-left-89879f66475909b0035d1385d0bcd6e2.svg";